export default __webpack_public_path__ + "static/media/minus.3bafc1f5.svg";